export default __webpack_public_path__ + "static/media/6.bc6f7eb8.jpg";